import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-title-modal',
    templateUrl: './title-modal.component.html',
    styleUrls: ['./title-modal.component.scss'],
    standalone: false
})
export class TitleModalComponent implements OnInit {
  title: string = '';
  comment: string = '';

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
  }

  passBack() {
    this.activeModal.close({ title: this.title, comment: this.comment });
  }
}
